module.exports = __webpack_public_path__ + "img/认证.e1853b0d.png";